import { EventEmitter } from 'events';

export default class EMFDebugger extends EventEmitter {
  constructor () {
    super();

    this.container = new THREE.Object3D();
    this.container.scale.set(0.001, 0.001, 0.001);

    this.index = 0;
    this.colors = [
      new THREE.Color(0xff0000),
      new THREE.Color(0x00dd00),
      new THREE.Color(0x0000ff),
      new THREE.Color(0xffff00),
      new THREE.Color(0x00ffff),
      new THREE.Color(0xff00ff)
    ];
  }

  clear () {
    let n = this.container.children.length;
    for (let i = n - 1; i >= 0; i--) {
      let child = this.container.children[i];
      this.container.remove(child);
    }
  }

  debugPolygon (surfaces, holes) {
    surfaces.forEach(surface => this.container.add(this.createLine(surface)));
    holes.forEach(hole => this.container.add(this.createLine(hole, 0.001)));
  }

  debugClipper (path) {
    let points = path.map((p) => {
      return new THREE.Vector3(p.X, p.Y, 0);
    });
    this.addLine(points);
  }

  addLine (points, color) {
    let geom = new THREE.Geometry();
    geom.vertices = points;

    let line = new THREE.Line(
      geom,
      new THREE.LineBasicMaterial({
        color: (color === undefined) ? (this.colors[(this.index++) % this.colors.length]) : color
      })
    );
    this.container.add(line);
  }

  addPoints (vertices, color, size = 0.04) {
    let geom = new THREE.Geometry();
    geom.vertices = vertices;

    color = (color === undefined) ? this.colors[this.container.children.length % this.colors.length] : color;

    let points = new THREE.Points(
      geom,
      new THREE.PointsMaterial({
        color: color,
        size: size
      })
    );

    this.container.add(points);
  }

  createLine (points, offset = 0) {
    let geom = new THREE.Geometry();

    for (let i = 0, n = points.length; i < n; i++) {
      let p = points[i];
      geom.vertices.push(new THREE.Vector3(p.x, offset, p.y));
    }
    geom.vertices.push(new THREE.Vector3(points[0].x, offset, points[0].y)); // loop

    return new THREE.Line(
      geom,
      new THREE.LineBasicMaterial({
        color: this.colors[(this.index++) % this.colors.length]
      })
    );
  }

  createSphere (pos) {
    if (this.debugSphere == null) {
      let geo = new THREE.SphereGeometry(40, 32, 32);
      let mat = new THREE.MeshBasicMaterial({color: 0xffff00});
      this.debugSphere = new THREE.Mesh(geo, mat);
      this.container.add(this.debugSphere);
    }
    this.debugSphere.position.set(pos.x, pos.y, pos.z);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/EMFDebugger.js